import { render } from "./PrivacyPolicy.vue?vue&type=template&id=11d9e9d1&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=11d9e9d1&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d9e9d1"]])

export default __exports__